import type { FC } from 'react'
import type { To } from 'react-router-dom'

import { BookingSummaryAccommodationLoading } from '../../../common'
import { LayoutHistoryDetailsLoading } from '../common'

interface HistoryDetailsAccommodationLoadingProps {
  backNavigationPath: To
}

export const HistoryDetailsAccommodationLoading: FC<HistoryDetailsAccommodationLoadingProps> = ({
  backNavigationPath,
}) => {
  return (
    <LayoutHistoryDetailsLoading backNavigationPath={backNavigationPath}>
      <BookingSummaryAccommodationLoading />
      {/* // TODO 4407: Temporarily hide the price summary until a bug in HotelLinx is fixed */}
      {/* //  https://dev.azure.com/HolidayClubResorts/Digital%20Transformation/_workitems/edit/4407 */}
      {/* // <BookingSummaryPriceLoading /> */}
    </LayoutHistoryDetailsLoading>
  )
}
